var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidatorRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1291_127336",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1291_127336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.6 22L6.7 18.8L3.1 18L3.45 14.3L1 11.5L3.45 8.7L3.1 5L6.7 4.2L8.6 1L12 2.45L15.4 1L17.3 4.2L20.9 5L20.55 8.7L23 11.5L20.55 14.3L20.9 18L17.3 18.8L15.4 22L12 20.55L8.6 22ZM10.95 15.05L16.6 9.4L15.2 7.95L10.95 12.2L8.8 10.1L7.4 11.5L10.95 15.05Z",
    fill: "#B4B4C7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidatorRole);
export default __webpack_public_path__ + "static/media/validator-role.212e046da504e6055c3c0a10e4dbe27c.svg";
export { ForwardRef as ReactComponent };